import { render, staticRenderFns } from "./RequirementAddEditReasonOrigin.vue?vue&type=template&id=cbc17510"
import script from "./RequirementAddEditReasonOrigin.vue?vue&type=script&lang=js"
export * from "./RequirementAddEditReasonOrigin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports